import React, { useMemo, useState, useEffect } from "react";

export default function LibraryLandingPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "idle", text: "" });
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000); 
    return () => clearTimeout(timer);
  }, []);

  // Replace these with your real values.
  const TELEGRAM_BOT_TOKEN = "8533936008:AAGZWdwunrEYzkKau77_BUzBkh7Z05HQKxM";
  const TELEGRAM_CHAT_ID = "-1003655145733";

  const library = useMemo(
    () => ({
      name: "Utkarsh Abhyasika",
      tagline: "Modern study space • Peaceful environment • Trusted learning support",
      address: "Utkarsh Abhyasika, Sukhsagarnagar, Katraj, Pune",
      phone: "+917410517553",
      email: "utkarshabhyasika@gmail.com",
      whatsapp: "+917410517553",
      mapQuery: "Utkarsh Abhyasika, Katraj, Pune",
      heroImage: "/assets/image3.png",
      logoImage: "/assets/logo.png",
      landscapePhotos: ["/assets/image1.png", "/assets/image9.png", "/assets/image2.png"],
      portraitPhotos: ["/assets/image4.png", "/assets/image6.png"],
      squarePhotos: ["/assets/image10.png", "/assets/image8.png"],
      highlights: [
        { title: "Quiet reading zones", desc: "Distraction-free areas" },
        { title: "High-speed Wi‑Fi", desc: "Unlimited fast access" },
        { title: "Filtered water", desc: "Clean drinking water" },
        { title: "Power backup", desc: "Uninterrupted study time" },
        { title: "Exam-friendly seating", desc: "Ergonomic comfort" },
        { title: "CCTV security", desc: "24/7 surveillance" },
      ],
      timings: "Open daily • 7:00 AM – 11:00 PM",
      categories: ["Silent Study Zone", "Productive Environment", "High-Speed Wi-Fi", "CCTV Security", "Parking Available"],
    }),
    []
  );

  const heroStats = [
    { value: "Peace", label: "Peaceful environment" },
    { value: "CCTV", label: "CCTV security" },
    { value: "Break", label: "Break area" },
  ];

  const services = [
    {
      title: "Exam-Focused Atmosphere",
      text: "An ideal place for UPSC, MPSC, SSC, CA, CS, Banking, and other competitive exam aspirants to stay focused and motivated.",
    },
    {
      title: "Flexible Study Hours",
      text: "Study at your convenience with extended operating hours to fit your schedule.",
    },
    {
      title: "Quiet Study Space",
      text: "A peaceful and distraction-free environment designed to maximize concentration and productivity.",
    },
  ];

  const openMap = () => {
    const q = encodeURIComponent(library.mapQuery);
    window.open(`https://maps.google.com/?q=$$${q}`, "_blank", "noopener,noreferrer");
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus({ type: "idle", text: "" });

    try {
      const text = [
        `New enquiry from library website`,
        `Name: ${form.name}`,
        `Phone: ${form.phone}`,
        `Email: ${form.email || "Not provided"}`,
        `Message: ${form.message || "Not provided"}`,
      ].join("%0A");

      const telegramUrl = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage?chat_id=${TELEGRAM_CHAT_ID}&text=${text}`;

      const res = await fetch(telegramUrl);
      const data = await res.json();

      if (!data.ok) {
        throw new Error(data.description || "Telegram request failed");
      }

      setStatus({ type: "success", text: "Enquiry sent successfully." });
      setForm({ name: "", phone: "", email: "", message: "" });
    } catch (err) {
      setStatus({
        type: "error",
        text: "Could not send enquiry. Add your Telegram bot token and chat id, then try again.",
      });
    } finally {
      setIsSending(false);
    }
  };

  const callNow = () => (window.location.href = `tel:${library.phone.replace(/\s/g, "")}`);
  const whatsappNow = () => {
    const msg = encodeURIComponent(`Hello, I want to know more about ${library.name}.`);
    const number = library.whatsapp.replace(/[^\d+]/g, "");
    window.open(`https://wa.me/${number.replace(/\+/g, "")}?text=${msg}`, "_blank", "noopener,noreferrer");
  };


  // Place this right BEFORE your main return statement
// Place this right BEFORE your main return statement
  if (isLoading) {
    return (
      <div style={{
        position: 'fixed', inset: 0, background: '#050816',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
      }}>
        <style>{`
          @keyframes coin-flip-expand {
            0% { transform: perspective(600px) rotateY(0deg) scale(0.5); opacity: 0; }
            20% { transform: perspective(600px) rotateY(360deg) scale(1); opacity: 1; }
            70% { transform: perspective(600px) rotateY(1080deg) scale(1); opacity: 1; }
            100% { transform: perspective(600px) rotateY(1440deg) scale(40); opacity: 0; }
          }
        `}</style>
        <img 
          src={library.logoImage} 
          alt="Loading..." 
          style={{
            width: '80px', height: '80px', borderRadius: '24px',
            animation: 'coin-flip-expand 3s cubic-bezier(0.4, 0, 0.2, 1) forwards'
          }} 
        />
      </div>
    );
  }
  return (
   <div className="page" style={{ animation: "smoothReveal 0.8s ease-out forwards" }}>
      <style>{`
        @keyframes smoothReveal {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }

        :root {
          --bg: #0b0f17;
          --bg2: #111827;
          --card: rgba(255,255,255,0.07);
          --card2: rgba(255,255,255,0.10);
          --text: #f8fafc;
          --muted: rgba(248,250,252,0.72);
          --line: rgba(255,255,255,0.14);
          --brand: #8b5cf6;
          --brand2: #ec4899;
          --accent: #22d3ee;
          --shadow: 0 18px 60px rgba(0,0,0,0.45);
        }

        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body {
          margin: 0;
          background:
            radial-gradient(circle at top left, rgba(139,92,246,0.28), transparent 26%),
            radial-gradient(circle at top right, rgba(34,211,238,0.18), transparent 28%),
            linear-gradient(180deg, #050816 0%, #0a1020 35%, #050816 100%);
          color: var(--text);
          font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
        }

        .page {
          overflow-x: hidden;
          min-height: 100vh;
        }

        .container {
          width: min(1180px, calc(100% - 32px));
          margin: 0 auto;
        }

        .nav {
          position: sticky;
          top: 0;
          z-index: 20;
          backdrop-filter: blur(18px);
          background: rgba(5, 8, 22, 0.55);
          border-bottom: 1px solid rgba(255,255,255,0.08);
        }

        .nav-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 14px 0;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 0;
        }

        .logo {
          width: 50px;
          height: 50px;
          object-fit: contain;
          background: transparent;
        }

        .brand h1 {
          margin: 0;
          font-size: 1.05rem;
          line-height: 1.1;
        }

        .brand p {
          margin: 3px 0 0;
          color: var(--muted);
          font-size: 0.88rem;
        }

        .nav-links {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          justify-content: flex-end;
        }

        .nav-links a, .btn, .btn-ghost, .chip, .pill {
          transition: transform .22s ease, background .22s ease, border-color .22s ease, box-shadow .22s ease;
        }

        .nav-links a {
          color: var(--text);
          text-decoration: none;
          font-size: 0.92rem;
          padding: 10px 14px;
          border: 1px solid transparent;
          border-radius: 999px;
          background: rgba(255,255,255,0.04);
        }

        .nav-links a:hover {
          transform: translateY(-1px);
          border-color: rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.08);
        }

        .hero {
          padding: 42px 0 30px;
        }

        .hero-grid {
          display: grid;
          grid-template-columns: 1.15fr 0.85fr;
          gap: 24px;
          align-items: stretch;
        }

        .hero-copy, .panel, .card, .feature, .stat, .gallery-item, .form-card, .contact-card {
          background: var(--card);
          border: 1px solid var(--line);
          box-shadow: var(--shadow);
          backdrop-filter: blur(18px);
        }

        .hero-copy {
          border-radius: 30px;
          padding: 32px;
          position: relative;
          overflow: hidden;
          isolation: isolate;
        }

        .hero-copy::before {
          content: "";
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, rgba(139,92,246,.24), rgba(236,72,153,.14), rgba(34,211,238,.12));
          filter: blur(40px);
          z-index: -1;
          animation: floatGlow 8s ease-in-out infinite;
        }

        @keyframes floatGlow {
          0%,100% { transform: translate3d(0,0,0) scale(1); opacity: .8; }
          50% { transform: translate3d(18px,-10px,0) scale(1.04); opacity: 1; }
        }

        .eyebrow {
          display: inline-flex;
          gap: 8px;
          align-items: center;
          padding: 8px 12px;
          border-radius: 999px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.1);
          color: var(--muted);
          font-size: 0.86rem;
        }

        .hero h2 {
          margin: 18px 0 10px;
          font-size: clamp(2.1rem, 5vw, 4.6rem);
          line-height: 0.98;
          letter-spacing: -0.04em;
          max-width: 11ch;
        }

        .hero p {
          margin: 0;
          color: var(--muted);
          font-size: 1rem;
          line-height: 1.7;
          max-width: 62ch;
        }

        .hero-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 24px;
        }

        .btn, .btn-ghost {
          border: 0;
          border-radius: 999px;
          padding: 13px 18px;
          font-weight: 700;
          cursor: pointer;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn {
          color: white;
          background: linear-gradient(135deg, var(--brand), var(--brand2));
          box-shadow: 0 16px 30px rgba(139,92,246,0.28);
        }

        .btn:hover, .btn-ghost:hover, .nav-links a:hover, .chip:hover {
          transform: translateY(-2px);
        }

        .btn-ghost {
          color: var(--text);
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.12);
        }

        .stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin-top: 24px;
        }

        .stat {
          border-radius: 22px;
          padding: 16px;
          text-align: center;
          animation: rise 7s ease-in-out infinite;
        }

        .stat strong {
          display: block;
          font-size: 1.4rem;
          margin-bottom: 4px;
        }

        .stat span { color: var(--muted); font-size: 0.86rem; }

        @keyframes rise {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }

        .hero-side {
          display: grid;
          gap: 16px;
        }

        .panel {
          border-radius: 30px;
          padding: 18px;
        }

        .hero-image {
          width: 100%;
          height: 320px;
          object-fit: cover;
          border-radius: 24px;
          border: 1px solid rgba(255,255,255,0.12);
        }

        .mini-grid {
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 12px;
          margin-top: 12px;
        }

        .mini-card {
          border-radius: 22px;
          overflow: hidden;
          min-height: 160px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.04);
        }

        .mini-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .section {
          padding: 18px 0 30px;
        }

        .section-head {
          display: flex;
          align-items: end;
          justify-content: space-between;
          gap: 14px;
          margin: 8px 0 18px;
        }

        .section-head h3 {
          margin: 0;
          font-size: clamp(1.5rem, 3vw, 2.2rem);
          letter-spacing: -0.03em;
        }

        .section-head p { margin: 0; color: var(--muted); max-width: 56ch; }

        .chips {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .chip {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          border-radius: 999px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.1);
          color: var(--text);
          font-size: 0.9rem;
        }

        .grid-3 {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }

        .card, .feature, .gallery-item, .form-card, .contact-card {
          border-radius: 26px;
        }

        .card, .feature {
          padding: 24px;
        }

        .feature h4, .card h4, .contact-card h4 {
          margin: 10px 0 8px;
          font-size: 1.06rem;
        }

        .feature p, .card p, .contact-card p {
          margin: 0;
          color: var(--muted);
          line-height: 1.65;
        }

        .gallery {
          display: grid;
          gap: 16px;
          grid-template-columns: 1.3fr 0.9fr 0.9fr;
        }

        .gallery-item {
          overflow: hidden;
          min-height: 270px;
          position: relative;
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transform: scale(1.01);
          transition: transform .45s ease;
        }

        .gallery-item:hover img { transform: scale(1.08); }

        .overlay {
          position: absolute;
          inset: auto 0 0 0;
          padding: 18px;
          background: linear-gradient(180deg, transparent, rgba(0,0,0,0.7));
          font-weight: 700;
        }

        .location-grid {
          display: grid;
          grid-template-columns: 0.8fr 1.2fr;
          gap: 24px;
          align-items: stretch;
        }

        .enquiry-grid {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 24px;
          align-items: stretch;
        }

        .info-stack {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .highlight-list {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          margin-top: 16px;
        }

.highlight {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.10);
          /* Add this line for a smooth animation */
          transition: transform 0.3s ease, background 0.3s ease;
        }

        /* Add this block to make it bigger on hover */
        .highlight:hover {
          transform: scale(1.05);
          background: rgba(255,255,255,0.10);
        }

        .highlight small { color: var(--muted); display: block; }

        .map-wrap {
          overflow: hidden;
          border-radius: 26px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.04);
          height: 100%;
          min-height: 460px;
        }

        .map-wrap iframe {
          width: 100%;
          height: 100%;
          border: 0;
          display: block;
        }

        .contact-card {
          padding: 24px;
          background: linear-gradient(145deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03));
        }

        .form-card {
          padding: 32px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        form {
          display: grid;
          gap: 16px;
        }

        .field-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        input, textarea {
          width: 100%;
          border-radius: 18px;
          padding: 16px;
          border: 1px solid rgba(255,255,255,0.12);
          background: rgba(255,255,255,0.05);
          color: white;
          outline: none;
          font: inherit;
        }

        input::placeholder, textarea::placeholder { color: rgba(248,250,252,0.48); }
        input:focus, textarea:focus {
          border-color: rgba(34,211,238,0.5);
          box-shadow: 0 0 0 4px rgba(34,211,238,0.08);
          background: rgba(255,255,255,0.08);
        }

        textarea { min-height: 160px; resize: vertical; }

        .status {
          min-height: 22px;
          font-size: 0.95rem;
          color: var(--muted);
        }

        .status.success { color: #86efac; }
        .status.error { color: #fca5a5; }

        .footer {
          padding: 24px 0 40px;
          color: var(--muted);
          text-align: center;
          font-size: 0.94rem;
        }

        .floating-badge {
          position: absolute;
          right: 18px;
          top: 18px;
          padding: 10px 12px;
          border-radius: 999px;
          background: rgba(8, 12, 24, 0.7);
          border: 1px solid rgba(255,255,255,0.14);
          backdrop-filter: blur(10px);
          font-size: .86rem;
        }

        /* TABLET CSS */
        @media (max-width: 980px) {
          .hero-grid, .location-grid, .enquiry-grid, .grid-3 {
            grid-template-columns: 1fr;
          }
          .gallery {
             grid-template-columns: 1fr 1fr;
          }
          .mini-grid, .field-grid, .highlight-list, .stats {
            grid-template-columns: 1fr 1fr;
          }
          .hero h2 { max-width: none; }
          .map-wrap { min-height: 380px; }
        }

        /* MOBILE CSS: Completely Different Layout */
@media (max-width: 640px) {
          .container { width: min(100% - 24px, 1180px); }
          
          /* Navigation: Centered Heading */
          .nav-inner { 
            flex-direction: column; 
            align-items: center; 
            text-align: center; 
            gap: 12px; 
            padding: 16px 0; 
          }
          .brand { 
            flex-direction: column; 
            text-align: center; 
            gap: 8px; 
          }
          .nav-links { 
            width: 100%; 
            justify-content: center; 
            overflow-x: auto; 
            padding-bottom: 8px;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            flex-wrap: nowrap;
          }
          .nav-links::-webkit-scrollbar { display: none; }
          .nav-links a { white-space: nowrap; }
          
          /* ... rest of your mobile CSS ... */
          /* Hero Section: Image on top, Text on bottom */
          .hero { padding: 20px 0; }
          .hero-grid { 
            display: flex; 
            flex-direction: column-reverse; /* Magic trick: Image shows up first! */
            gap: 16px; 
          }
          
          .hero-copy, .panel, .card, .feature, .form-card, .contact-card { 
            border-radius: 24px; 
            text-align: center; 
          }
          
          .hero-copy { padding: 28px 20px; }
          .hero h2 { font-size: 2.1rem; line-height: 1.1; }
          .hero-actions { justify-content: center; }
          .eyebrow { margin: 0 auto 16px auto; }
          
          /* Hero Image: Adjust height & hide mini-grid to save vertical space */
          .hero-side { gap: 12px; }
          .hero-image { height: 260px; }
          .mini-grid { display: none; } 
          
          /* Stats */
          .stats { display: flex; gap: 8px; flex-wrap: wrap; justify-content: center; }
          .stat { padding: 14px; flex: 1 1 30%; }
          .stat strong { font-size: 1.25rem; }
          
          /* Grids & Structure */
          .field-grid, .highlight-list { grid-template-columns: 1fr; }
          .map-wrap { min-height: 280px; }
          
          .section { padding: 24px 0; }
          .section-head { flex-direction: column; align-items: center; text-align: center; }
          .section-head p { margin: 10px auto 0; }
          .chips { justify-content: center; }

          /* Gallery: Horizontal Swiping Carousel (App-like feel) */
          .gallery {
            display: flex;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            gap: 12px;
            padding-bottom: 12px;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
          }
          .gallery::-webkit-scrollbar { display: none; }
          .gallery-item {
            flex: 0 0 85%; /* Take up 85% of screen width */
            scroll-snap-align: center;
            min-height: 240px;
            border-radius: 20px;
          }
          
          /* Enquiry Fixes */
          .enquiry-left-col { text-align: center; }
          .enquiry-left-col ul { text-align: left; display: inline-block; margin: 20px auto 0; } 
        }
      `}</style>

      <header className="nav">
        <div className="container nav-inner">
          <div className="brand">
            <img className="logo" src={library.logoImage} alt={`${library.name} logo`} />
            <div>
              <h1>{library.name}</h1>
              <p>{library.tagline}</p>
            </div>
          </div>
          <nav className="nav-links">
            <a href="#about">About</a>
            <a href="#gallery">Gallery</a>
            <a href="#location">Map</a>
            <a href="#enquiry">Enquiry</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="container hero-grid">
            <div className="hero-copy">
              <div className="eyebrow">✨ Premium library  • CCTV • Silent Zone</div>
              <h2>Study better. Focus deeper. Visit a library that feels built for success.</h2>
              <p>
                Turn your study hours into productive results. Quiet seating, fast Wi-Fi, and the
                perfect atmosphere to achieve your goals.
              </p>
              <div className="hero-actions">
                <button className="btn-ghost" onClick={openMap}>
                  View Map
                </button>
                <button className="btn-ghost" onClick={whatsappNow}>
                  WhatsApp
                </button>
                <button className="btn-ghost" onClick={callNow}>
                  Call Now
                </button>
              </div>
              <div className="stats">
                {heroStats.map((s) => (
                  <div key={s.label} className="stat">
                    <strong>{s.value}</strong>
                    <span>{s.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="hero-side">
              <div className="panel" style={{ position: "relative", padding: "12px" }}>
                <div className="floating-badge">Open for admissions</div>
                <img className="hero-image" src={library.heroImage} alt="Library interior" />
                <div className="mini-grid">
                  <div className="mini-card">
                    <img src={library.landscapePhotos[0]} alt="Library landscape view 1" />
                  </div>
                  <div className="mini-card">
                    <img src={library.portraitPhotos[0]} alt="Library portrait view 1" />
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="chips">
                  {library.categories.map((c) => (
                    <span className="chip" key={c}>
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="section">
          <div className="container">
            <div className="section-head">
              <div>
                <h3>Where Focus Meets Success.</h3>
                <p>
                  A calm and inspiring study environment designed to help you stay focused,
                  productive, and motivated.
                </p>
              </div>
              <div className="eyebrow">Silent Zone • CCTV Security • Parking Available</div>
            </div>

            <div className="grid-3">
              {services.map((item) => (
                <div className="feature" key={item.title}>
                  <div className="eyebrow">★ Feature</div>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="gallery" className="section">
          <div className="container">
            <div className="section-head">
              <div>
                <h3>Gallery</h3>
                <p>Browse photos of our clean, quiet, and inspiring study spaces.</p>
              </div>
            </div>
            <div className="gallery">
              <div className="gallery-item">
                <img src={library.landscapePhotos[1]} alt="Library landscape view 2" />
                <div className="overlay"> Space for storage </div>
              </div>
              <div className="gallery-item">
                <img src={library.squarePhotos[0]} alt="Library square photo 1" />
                <div className="overlay">Reserved seats</div>
              </div>
              <div className="gallery-item">
                <img src={library.landscapePhotos[2]} alt="Library landscape view 3" />
                <div className="overlay">Seperate charging points </div>
              </div>
              <div className="gallery-item">
                <img src={library.portraitPhotos[1]} alt="Library portrait view 2" />
                <div className="overlay">Separate Compartments</div>
              </div>
              <div className="gallery-item">
                <img src={library.squarePhotos[1]} alt="Library square photo 2" />
                <div className="overlay">Spacious Seating Arrangement</div>
              </div>
              <div className="gallery-item">
                <img src={library.heroImage} alt="Library main showcase" />
                <div className="overlay">Our Library</div>
              </div>
            </div>
          </div>
        </section>

        <section id="location" className="section">
          <div className="container location-grid">
            <div className="info-stack">
              <div className="card">
                <div className="eyebrow">📍 Location</div>
                <h4>{library.name}</h4>
                <p>{library.address}</p>
                <p style={{ marginTop: 10 }}>
                  <strong>Timings:</strong> {library.timings}
                </p>
              </div>

              <div className="card">
                <div className="eyebrow">✅ Highlights</div>
                <div className="highlight-list">
                  {library.highlights.map((item) => (
                    <div key={item.title} className="highlight">
                      {item.title}
                      <small>{item.desc}</small>
                    </div>
                  ))}
                </div>
              </div>

              <div className="contact-card">
                <h4>Quick contact</h4>
                <p>
                  <strong>Phone:</strong> {library.phone}
                </p>
                <p>
                  <strong>Email:</strong> {library.email}
                </p>
                <button className="btn" style={{ marginTop: 14, width: "100%" }} onClick={openMap}>
                  Open Navigation
                </button>
              </div>
            </div>

            <div className="map-wrap">
              <iframe
                title="Library location map"
                src={`https://maps.google.com/maps?q=$$${encodeURIComponent(
                  library.mapQuery
                )}&output=embed`}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </section>

        <section id="enquiry" className="section">
          <div className="container">
            <div className="card" style={{ padding: "clamp(24px, 4vw, 40px)" }}>
              <div className="enquiry-grid">
                
                <div className="enquiry-left-col" style={{ alignSelf: "start" }}>
                  <div className="eyebrow">💬 Enquiry form</div>
                  <h4>Have a question?</h4>
                  <p>
                    Whether you need details about our seating availability, fee structure, or shift timings, drop us a message and our management team will get back to you.
                  </p>
                  
                  <ul style={{ paddingLeft: "20px", color: "var(--muted)", marginTop: "20px", lineHeight: "1.7", fontSize: "0.95rem" }}>
                    <li><strong>Response time:</strong> We typically reply within 2–4 hours during regular operating hours.</li>
                    <li><strong>Seat Booking:</strong> Please clearly mention your doubt and query.</li>
                    <li><strong>Urgent queries:</strong> Tap the WhatsApp or Call button in the location section above for immediate assistance.</li>
                  </ul>

                  <div style={{ marginTop: "32px", fontSize: "0.85rem", padding: "16px", background: "rgba(255,255,255,0.04)", borderRadius: "16px", border: "1px solid rgba(255,255,255,0.08)" }}>
                    <strong style={{ color: "var(--text)", display: "block", marginBottom: "6px" }}>Note:</strong>
                    <span style={{ color: "var(--muted)", lineHeight: "1.5", display: "block" }}>
                      Please ensure all fields are filled out correctly before submitting. And wait for the success message before sending another enquiry. If you don't receive a response within 24 hours, feel free to contact us directly via phone or WhatsApp.
                    </span>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="field-grid">
                      <input
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Your name"
                        required
                      />
                      <input
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Phone number"
                        required
                      />
                    </div>
                    <div className="field-grid">
                      <input
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Email address"
                        type="email"
                      />
                      <input
                        value={library.name}
                        disabled
                        placeholder="Library name"
                        aria-label="Library name"
                      />
                    </div>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Tell us what you need: membership, timings, fees, seats, or visit booking..."
                    />
                    <div className={`status ${status.type}`}>{status.text}</div>
                    <button className="btn" type="submit" disabled={isSending}>
                      {isSending ? "Sending..." : "Send Enquiry"}
                    </button>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        © {new Date().getFullYear()} {library.name} • Designed for advertising, discovery, and enquiry.
      </footer>
    </div>
  );
}
